import { css } from '@emotion/react';

/** Shared height constraints for the inner value slot inside `LabeledInputPresenter`. */
export const LABELED_INPUT_SLOT_SIZE_STYLES = {
  tiny: css`
  `,
  tightSmall: css`
    height: 32px;
    min-height: 32px;
    max-height: 32px;
  `,
  small: css`
    height: 32px;
    min-height: 32px;
    max-height: 32px;
  `,
  medium: css`
    height: 44px;
    min-height: 44px;
    max-height: 44px;
  `,
  tightMedium: css`
    height: 44px;
    min-height: 44px;
    max-height: 44px;
  `,
  large: css`
    height: 50px;
    min-height: 50px;
    max-height: 50px;
  `,
};
